import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import * as fromApp from '@store';
import { DocusignTemplate } from '@shared/models/docusign-template.model';
import { EnrollmentGroupService } from '@core/api/enrollment-group.service';

export interface DialogData {
}

@Component({
  selector: 'fc-dialog-send-edoc',
  templateUrl: './dialog-send-edoc.component.html',
  styleUrls: ['./dialog-send-edoc.component.scss'],
  standalone: false
})
export class DialogSendEdocComponent implements OnInit {
  selectEdocTemplateForm: UntypedFormGroup;
  templates: DocusignTemplate[];

  constructor(
    public dialogRef: MatDialogRef<DialogSendEdocComponent>,
    readonly formBuilder: UntypedFormBuilder,
    readonly enrollmentGroupService: EnrollmentGroupService,
    readonly store: Store<fromApp.AppState>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
  }

  ngOnInit() {
    this.selectEdocTemplateForm = this.formBuilder.group({
      templateId: ['', Validators.required],
    });
    this.enrollmentGroupService.getEdocTemplates().subscribe((response: any) => {
      this.templates = response;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    this.dialogRef.close(this.selectEdocTemplateForm.value.templateId);
  }
}
